export const BOX_TYPES = {
  MAILER: 'Mailer',
  LITERATURE: 'Literature',
  INDESTRUCTO: 'Indestructo',
  SHIPPING: 'Shipping',
  PIZZA: 'Pizza'
};

export const BOX_TYPES_MAP = {
  mbti : BOX_TYPES.LITERATURE,
  mbtl : BOX_TYPES.MAILER,
  mbties: BOX_TYPES.INDESTRUCTO,
  sb : BOX_TYPES.SHIPPING,
  pb: BOX_TYPES.PIZZA
}

export const TYPE_SLUG_MAP = {
  mbti: "TUCK-IN MAILER",
  mbtl: "TAB LOCKING MAILER",
  mbties: "TUCK-IN MAILER EXTRA STONG",
  sb: "SHIPPING BOX",
  pb: "PIZZA BOX"
}

const MATERIALS = {
  kraft: "kraft",
  white: "white"
}

export const MATERIAL_SLUG_MAP = {
  kk: { outside: MATERIALS.kraft, inside: MATERIALS.kraft },
  wk: { outside: MATERIALS.white, inside: MATERIALS.kraft },
  ww: { outside: MATERIALS.white, inside: MATERIALS.white }
}
